import { getPortfolioNewsFeed } from '@simplywallst/services';
import { useQuery } from '@tanstack/react-query';

export async function queryFn(portfolioId: string) {
  const response = await getPortfolioNewsFeed(portfolioId);
  return response.data;
}

export const useNewsFeed = (portfolioId: string) => {
  const getQueryKey = (portfolioId: string) => {
    return ['portfolioNewsFeed', portfolioId];
  };

  return useQuery({
    queryKey: getQueryKey(portfolioId),
    queryFn: async () => queryFn(portfolioId),
  });
};
